import styled from 'styled-components';
import { AllieButton } from '../../../components/Buttons/Button';

const namespace = 'efficiency-wizard';

export const EfficiencyWizardContainer = styled.div`
  /* padding: 20px 24px; */
  width: 100%;
  height: 100%;
  flex: 1;
  min-height: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .${namespace} {
    display: flex;
    flex-direction: column;
    row-gap: 25px;
    flex: 1;
    min-height: 0;
    height: 100%;

    &__buttons {
      display: flex;
      column-gap: 16px;
      justify-content: flex-end;

      ion-button {
        letter-spacing: normal;
        --border-radius: var(--allie-radius-md) !important;
        margin: 0;
        --padding-top: 16px;
        --padding-bottom: 16px;
        --padding-start: 24px;
        --padding-end: 24px;

        > span {
          font-size: 16px;
        }
      }

      &__button-prev {
        --background: var(--allie-color-primary-5) !important;
        --color: var(--allie-color-primary-70) !important;
        --color-hover: var(--allie-color-primary-50) !important;
      }

      &__button-cancel {
        --background: var(--allie-color-primary-5) !important;
        --color: var(--allie-color-primary-70) !important;
        --color-hover: var(--allie-color-primary-50) !important;
      }
    }

    &__progress {
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 16px;
      margin-top: 36px;

      &__item {
        display: inline-flex;
        width: 1rem;
        height: 1rem;
        background: var(--allie-color-primary-20);
        text-decoration: none;
        border-radius: 50%;

        &--active {
          background: var(--allie-color-primary-60);
        }
      }
    }

    &__footer {
      padding: 0 24px 20px;
      box-sizing: border-box;
    }

    &__pages {
      scrollbar-width: initial;
      scrollbar-color: initial;

      &::-webkit-scrollbar {
        width: 5px;
      }

      &::-webkit-scrollbar-button {
        display: none;
      }

      &::-webkit-scrollbar-track {
        background-color: var(--allie-color-neutral-30);
        border-radius: 10px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: var(--allie-color-neutral-50);
        border-radius: 10px;
        border: none;
      }
    }
  }
`;

export const StyledCancelButton = styled(AllieButton)`
  --background: var(--allie-color-primary-5) !important;
  --color: var(--allie-color-primary-70) !important;
  --color-hover: var(--allie-color-primary-50) !important;
  --border-radius: var(--allie-radius-md) !important;
`;

export const StyledGoBackButton = styled(AllieButton)`
  width: fit-content;
  color: var(--allie-color-neutral-60);
  --background: white;
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  border: 1px solid var(--allie-color-neutral-30);
  border-radius: var(--allie-radius-xs);
`;

export const StyledTitleContainer = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;
  height: 100%;
  width: 100%;
`;

export const StyledHeaderContainer = styled.div`
  padding: 20px 24px 0;
  box-sizing: border-box;
`;

export const NoteContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-lg);
  width: 100%;
`;

export const QuickConfirmFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 10px;

  & > * {
    flex: 1;
  }
`;

export const WizardHeader = styled.header`
  width: 100%;
  padding: 20px 24px 16px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--allie-color-neutral-20);
`;

export const WizardHeaderTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
`;

export const WizardHeaderCloseButton = styled.button`
  border: 0;
  background: transparent;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--allie-color-neutral-60);
`;

export const FlexCenter = styled.div`
  display: flex;
`;

export const SubtitleText = styled.div`
  margin-top: 4px;
`;

export const ContentLoadingStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
  min-height: 0;
  padding: 1.25rem 1.75rem;
  box-sizing: border-box;
  width: 100%;
  overflow-y: auto;
  scrollbar-color: var(--allie-color-neutral-40) var(--allie-color-neutral-10);
`;
